EBContext.modules.TabSync = function(){
	var tsSelf = this;
	this.updates = {};
	this.reloadBlocks = [];
	this.updateEvent = new Event('EBContext.tabSync.update', {'bubbles': true, 'cancellable': false, 'composed': true});
	/** 
	 * Toto ID by m�lo b�t unik�tn� mezi str�nkami na stejn�m serveru (d�ky sessionID),
	 * a pro miziv� p��pad stejn�ho sessionID na r�zn�ch serverech se kontroluje je�t� i serverName 
	*/
	//this.syncID = EBContext.config.serverName + '_' + EBContext.config.sessionID+'.tabSync';
	this.syncID = 'tabSync'; // Nen� pot�eba vym��let unik�tn� ID, proto�e LocalStorage nepodporuje CORS

	/** Nastav� prom�nnou v localStorage, ��m� odp�l� event 'storage' v ostatn�ch z�lo�k�ch/oknech */
	this.update = function(type, data){
		if(typeof Storage === 'undefined') return;
		localStorage.setItem(tsSelf.syncID, JSON.stringify({
			rnd: new Date().getTime() + Math.random(),	// Kv�li kontrole, zda byla do p�i p�ed�n� stejn�ch dat do storage p�eulo�en� zrovna hodnota syncID
			type: type,
			data: data
		}));
	};
	
	/** Merge reloadBlocks array pro aktualizaci obsahu aktu�ln� str�nky*/
	this.reload = function(reloadBlocks){
		tsSelf.reloadBlocks = EBContext.utils.array.merge(tsSelf.reloadBlocks, reloadBlocks);
	};
	
	/** 
	 * Ode�le nashrom�d�nou frontu AJAX request� pro aktualizaci obsahu
	 * Nap�. pokud je aktu�ln� str�nka v�pis obl�ben�ch produkt�, a na jin� z�lo�ce p�id�v�m/odeb�r�m produkty z obl�ben�ch, 
	 * tak se p�es tabSync ulo�� ajaxRequest na aktualizaci str�nky nebo na�ten� produkt�, a po�le se a� kdy� se u�ivatel na tuto z�lo�ku p�epne
	 */
	this.load = function(){
		if(document.visibilityState === 'visible'){
			
			// U�ivatel se vr�til na tuto z�lo�ku - aktualizovat obsah z nashrom�d�n�ch dat
			document.dispatchEvent(tsSelf.updateEvent);
			
			setTimeout(function(){
				// U�ivatelsk� eventy b�� v�dy synchronn�, tak�e po odp�len� update eventu m��u vypr�zdnit nashrom�d�n� data, proto�e u� nebudou relevantn�
				tsSelf.updates = {};
				
				var i, j;
				
				// Reloadnout pot�ebn� bloky str�nky
				if(tsSelf.reloadBlocks.length){
					
					// Pokud jsou v seznamu bloky s hv�zdi�kou, i bez, tak ty s hv�zdi�kou odebere, a nechat jen ty, kter� reloaduj� i sv� HTML
					for(i=0;i<tsSelf.reloadBlocks.length;i++){
						if(tsSelf.reloadBlocks[i][0] === '*'){
							j = tsSelf.reloadBlocks.indexOf(tsSelf.reloadBlocks[i].replace('*', ''));
							if(j>-1) tsSelf.reloadBlocks.splice(j,1);
						}
					}
					EBContext.ajaxNav.navigationTrigger(null, null, EBContext.ajaxNav.currentState.postData, {reload: tsSelf.reloadBlocks.join(','), navigation: false});
				}
				
				// Vynulovat reloads
				tsSelf.reloadBlocks = [];
			}, 0);
		}
	};
	
	// na�te updates z localstorage
	if(typeof Storage !== 'undefined'){
		window.addEventListener('storage', function(e){
			var updatedKey = e.key;
			
			if(updatedKey === tsSelf.syncID){
				
				//pokud opravdu do�lo ke zm�n� hodnoty a ne jen k p�eulo�en� ...
				if(e.newValue !== e.oldValue){
					//parsnout ze stringu objekt
					// { type: 'favorites', data: { ... } }
					var tabSyncObj = JSON.parse(localStorage[updatedKey]);
					
					//Pokud nen� objekt tohoto typu je�t� vytvo�en, tak jej vytvo�it
					if(!tsSelf.updates[tabSyncObj.type]){
						tsSelf.updates[tabSyncObj.type] = [];
					}
					
					//a za�adit jej do fronty
					tsSelf.updates[tabSyncObj.type].push(tabSyncObj.data);
					tsSelf.load();
				}
			}
		});
	}
	
	// zpracuje na�ten� updates
	document.addEventListener("visibilitychange", tsSelf.load);
};
EBContext.tabSync = new EBContext.modules.TabSync();

/* P��klad pou�it�:
- Cokoliv bude cht�t pou��vat tabSync si mus� pov�sit eventListener na 'EBContext.tabSync.update', a p�i jeho odp�len� zpracovat relevantn� data v EBContext.tabSync.updates
- Nap�. p�i synchronizaci obl�ben�ch polo�ek: 

document.addEventListener('EBContext.tabSync.update', function(){
 	var data = EBContext.tabSync.updates.favorites
 	if(data){
 		for(var i=0; i<data.length; i++){
 			// Zpracov�n� jednotliv�ch updat�
 		}
 	}
});

*/